import { memo, useCallback, useEffect, useState } from 'react';

import * as ModalWindows from '@Stores/ModalWindows';
import usePreorderDate from '@Queries/usePreorderDate';
import useTranslation from '@Queries/useTranslation';
import LinksList from '../../../LinksList';
import LoaderDots from '../LoaderDots';
import styles from './PreorderInfoLink.module.css';

import type { FC, HTMLAttributes } from 'react';

export interface PreorderInfoLinkProp extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  productId: number;
}

const PreorderInfoLink: FC<PreorderInfoLinkProp> = (props) => {
  const { productId, ...restProps } = props;
  const preorderDate = usePreorderDate({ productId });
  const { t } = useTranslation();
  const text = preorderDate.isSuccess && preorderDate.data.text;
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(preorderDate.isFetching);
  }, [preorderDate.isFetching]);

  const handleClick = useCallback(() => {
    ModalWindows.open('PreorderInformation');
  }, []);

  if (preorderDate.isError) {
    return null;
  }

  return (
    <LinksList
      {...restProps}
      items={[
        {
          hasArrow: true,
          label: (
            <div className={styles.text}>
              {loading ? <LoaderDots>{t('preorder-note')}</LoaderDots> : text}
            </div>
          ),
          onClick: handleClick,
        },
      ]}
    />
  );
};

export default memo(PreorderInfoLink);
